export class InvalidLoginCredentials extends Error {
  constructor(message) {
    super(message);
  }
}
